import '|/app.styl';
import '|/bootstrap.scss';

//Scripts
import OffsetHeight from './OffsetHeight';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        //
        new OffsetHeight();

    });

})(jQuery);